import { ChakraV3 } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';

export type DescriptionItem = {
  title: JSX.Element | string;
  content: JSX.Element | string;
};

interface Props extends ChakraV3.SimpleGridProps {
  items: DescriptionItem[];
}

export const DescriptionList = (props: Props) => {
  const { items, ...rest } = props;

  return (
    <ChakraV3.SimpleGrid
      columns={2}
      rowGap={4}
      columnGap={4}
      templateColumns='max-content auto'
      alignItems='start'
      {...rest}
    >
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {P.isString(item.title) ? (
            <ChakraV3.Box fontSize='sm' fontWeight='semibold'>
              {item.title}
            </ChakraV3.Box>
          ) : (
            <ChakraV3.Box>{item.title}</ChakraV3.Box>
          )}
          <ChakraV3.Box>{item.content}</ChakraV3.Box>
        </React.Fragment>
      ))}
    </ChakraV3.SimpleGrid>
  );
};
